/**
 * MSAL (Microsoft Authentication Library) 設定
 *
 * Azure ADマルチテナント認証の設定。
 * 別テナントのMicrosoftアカウントでログインを許可。
 */

import { LogLevel } from '@azure/msal-browser';

// 環境変数から設定を取得
const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || '';
const tenantId = process.env.REACT_APP_AZURE_TENANT_ID || 'common';
const redirectUri = process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin;

/**
 * MSAL設定オブジェクト
 */
export const msalConfig = {
  auth: {
    clientId: clientId,
    // 'common' を使用すると任意のAzure ADテナントからのログインを許可
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: redirectUri,
    postLogoutRedirectUri: redirectUri,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage', // sessionStorageも可
    storeAuthStateInCookie: true,  // IEやEdgeの互換性向上、リダイレクト問題の解決
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error('[MSAL]', message);
            return;
          case LogLevel.Info:
            console.info('[MSAL]', message);
            return;
          case LogLevel.Verbose:
            console.debug('[MSAL]', message);
            return;
          case LogLevel.Warning:
            console.warn('[MSAL]', message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Info,  // デバッグ用に詳細ログを有効化
    },
  },
};

/**
 * ログイン時に要求するスコープ
 */
export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
};

/**
 * API呼び出し時に要求するスコープ
 * (このアプリでは主にID Tokenのみ使用)
 */
export const apiRequest = {
  scopes: ['User.Read'],
};

/**
 * MSAL認証が設定されているかチェック
 */
export const isMsalConfigured = () => {
  return Boolean(clientId && clientId !== 'your-azure-client-id');
};

